<app-modal>
  <div modal-header>
    <h4 class="modal-title">Notification Detail</h4>
  </div>
  <div modal-body>
    <div class="mb-3">
      <span class="bold">Title</span>
      <div>{{ notification.title }}</div>
    </div>
    <div class="mb-3">
      <span class="bold">Created Date</span>
      <div>{{ notification.createdDate | date: "medium" }}</div>
    </div>
    <div class="mb-3">
      <span class="bold">Message</span>
      @if (content) {
        <div [innerText]="content.before"></div>
        <div [innerText]="content.after"></div>
      }
      @if (!content) {
        <div [innerText]="notification.message"></div>
      }
    </div>
  </div>
  <div modal-footer>
    <div class="row">
      <div class="col-6">
        <button
          (click)="softDelete()"
          class="btn btn-danger float-start"
          type="button"
        >
          <i class="feather-trash-2"></i> Delete
        </button>
      </div>
      <div class="col-6">
        <button
          (click)="dismiss()"
          class="btn btn-secondary"
          data-dismiss="modal"
          type="button"
        >
          <span>Close</span>
        </button>
        @if (content) {
          <button
            (click)="handleLinkClick()"
            class="btn btn-primary"
            type="button"
          >
            {{ content.linkText }}
          </button>
        }
      </div>
    </div>
  </div>
</app-modal>
